import React, { useState } from 'react';
import { Box, Link, TextField, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import globals from '../../../../globals/communityGlobals';

const locale = globals.getAreas(['externalProvider', 'userActions']);

export default function ClinicianMappingFilters({ setCliniciansBySurname }) {
  const [state, setState] = useState({
    surname: '',
  });

  const handleClear = () => {
    setState({ surname: '' });
    setCliniciansBySurname('');
  };

  return (
    <React.Fragment>
      <Box p={1} width={70} textAlign="end">
        <span>{locale.getMsg('surname')}</span>
      </Box>
      <Box p={1} flexGrow={1}>
        <TextField
          name="surname"
          value={state.surname}
          fullWidth
          onChange={e => setState({ surname: e.target.value })}
        />
      </Box>
      <Box p={1} flexGrow={1} width={30} />
      <Box p={1}>
        <Link
          className="cancel-link"
          onClick={() => {
            handleClear();
          }}
        >
          {locale.getMsg('clear')}
        </Link>
      </Box>
      <Box p={1}>
        <IconButton
          type="submit"
          size="small"
          onClick={() => {
            setCliniciansBySurname(state.surname);
          }}
          className="search-icon"
        >
          <SearchIcon />
        </IconButton>
      </Box>
    </React.Fragment>
  );
}
